import { useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { Logo } from "../brand/Logo";
import { NAV, waLink } from "../../lib/site";

const WhatsBtn = ({ testId, className = "" }) => (
  <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid={testId}
    className={`inline-flex items-center gap-2 rounded-full bg-[#F7F5F0] px-5 py-2.5 text-sm font-semibold text-[#196ABC] transition-colors hover:bg-white ${className}`}>
    <MessageCircle className="h-4 w-4" strokeWidth={2.5} /> Falar no WhatsApp
  </a>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed inset-x-0 top-0 z-40 bg-[#196ABC]/95 backdrop-blur-md" data-testid="site-header">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 sm:px-8">
        <a href="#inicio" data-testid="header-logo-link" aria-label="Clube do Contemplado — início">
          <Logo variant="horizontal" tone="white" className="hidden sm:inline-flex" />
          <Logo variant="symbol" tone="white" className="sm:hidden" />
        </a>
        <nav className="hidden items-center gap-7 lg:flex" aria-label="Principal">
          {NAV.map((n) => (
            <a key={n.id} href={`#${n.id}`} data-testid={`nav-link-${n.id}`}
              className="text-sm font-medium text-[#F7F5F0]/85 transition-colors hover:text-white">{n.label}</a>
          ))}
        </nav>
        <WhatsBtn testId="nav-whatsapp-cta" className="hidden lg:inline-flex" />
        <button className="rounded-xl p-2 text-[#F7F5F0] lg:hidden" onClick={() => setOpen(!open)}
          aria-label="Abrir menu" data-testid="mobile-menu-toggle">
          {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </div>
      {open && (
        <nav className="border-t border-white/10 bg-[#196ABC] px-5 pb-6 pt-2 lg:hidden" data-testid="mobile-menu">
          {NAV.map((n) => (
            <a key={n.id} href={`#${n.id}`} onClick={() => setOpen(false)} data-testid={`mobile-nav-link-${n.id}`}
              className="block border-b border-white/10 py-3.5 text-base font-medium text-[#F7F5F0]">{n.label}</a>
          ))}
          <WhatsBtn testId="mobile-whatsapp-cta" className="mt-5" />
        </nav>
      )}
    </header>
  );
};
